import {Routes} from '@angular/router';
import {UserDetailsComponent} from '../users/user-details/user-details.component';
import {EmployeesComponent} from './employees.component';

export const employeeRoutes: Routes = [
  {
    path: 'details/:id',
    data: {
      breadcrumb: 'user.firstName;user.lastName',
      isParam: true,
      renderFolderCrumbs: true
    },
    component: UserDetailsComponent
  },
  {
    path: '',
    component: EmployeesComponent
  }
];
